var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 404.01 321.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.4;}.cls-2,.cls-3,.cls-4{fill:#d8d8d8;}.cls-3{opacity:0.2;}.cls-27,.cls-4{opacity:0.5;}.cls-5{fill:#7dc3ea;}.cls-6{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_3);}.cls-7{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_9);}.cls-8{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13);}.cls-9{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_3-2);}.cls-10{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_9-2);}.cls-11{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-2);}.cls-12{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_3-3);}.cls-13{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_9-3);}.cls-14{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-3);}.cls-15{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_3-4);}.cls-16{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_9-4);}.cls-17{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-4);}.cls-18{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_18);}.cls-19{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_9-5);}.cls-20{fill:#5793ce;}.cls-21{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_441);}.cls-22,.cls-27{fill:#173d7a;}.cls-23{fill:#396caa;}.cls-24{fill:#06033e;opacity:0.3;}.cls-25{fill:#d4ecff;}.cls-26{fill:#ff2c9c;}.cls-28{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-5);}.cls-29{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45);}.cls-30{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-6);}.cls-31{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-2);}.cls-32{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-7);}.cls-33{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-3);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3",
    cx: 93.22,
    cy: 260.88,
    r: 33.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#274f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#173d7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_9",
    x1: 72.77,
    y1: 248.66,
    x2: 132.35,
    y2: 248.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#d0eafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c5e2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#b2d6f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#98c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86b8e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13",
    cx: 44.82,
    cy: 226.04,
    r: 60.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#699dd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6396cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#5184bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#396caa"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3-2",
    cx: 346.17,
    cy: 120.39,
    r: 33.67,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_9-2",
    x1: 325.71,
    y1: 108.17,
    x2: 385.29,
    y2: 108.17,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-2",
    cx: 297.76,
    cy: 85.54,
    r: 60.86,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3-3",
    cx: 346.17,
    cy: 260.88,
    r: 33.67,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_9-3",
    x1: 325.71,
    y1: 248.66,
    x2: 385.29,
    y2: 248.66,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-3",
    cx: 297.76,
    cy: 226.04,
    r: 60.86,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3-4",
    cx: 93.22,
    cy: 120.39,
    r: 33.67,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_9-4",
    x1: 72.77,
    y1: 108.17,
    x2: 132.35,
    y2: 108.17,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_9"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-4",
    cx: 44.82,
    cy: 85.54,
    r: 60.86,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_18",
    cx: 197.74,
    cy: 116,
    r: 121.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#396caa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274f89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_9-5",
    x1: 159.64,
    y1: 30.06,
    x2: 272.6,
    y2: 98.88,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_441",
    x1: -143.07,
    y1: 1279.98,
    x2: -76.68,
    y2: 1264.94,
    gradientTransform: "matrix(0.87, 0.5, 0, 1.15, 280.26, -1276.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3919bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6507fa"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-5",
    cx: 184.25,
    cy: 259.7,
    r: 43.62,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45",
    x1: 192.48,
    y1: 245.71,
    x2: 260.81,
    y2: 286.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d0eafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#c5e2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#b2d6f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#98c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#86b8e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-6",
    cx: 310.72,
    cy: 171.78,
    r: 43.62,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-2",
    x1: 318.96,
    y1: 157.79,
    x2: 387.29,
    y2: 198.53,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-7",
    cx: 57.78,
    cy: 171.78,
    r: 43.62,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-3",
    x1: 66.02,
    y1: 157.79,
    x2: 134.35,
    y2: 198.53,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xD1\\xEB\\xEE\\xE9_1",
    "data-name": "\\xD1\\xEB\\xEE\\xE9 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.72,88.81,341.43,70.75l31.28-18.06.28.16,31,17.9ZM343.65,70.75l29.07,16.78,29.06-16.78L372.71,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.36,88.81,281.08,70.75l31.28-18.06,31.29,18.06ZM283.29,70.75l29.07,16.78,29.07-16.78L312.36,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.54,106.23l-.28-.16-31-17.9,31.29-18.06,31.28,18.06ZM313.47,88.17,342.54,105l29.07-16.78L342.54,71.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.72,123.66l-.28-.16-31-17.91,31.29-18.06.27.16,31,17.9Zm-29.07-18.07,29.07,16.79,29.07-16.79L372.72,88.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252,88.81l-.28-.16-31-17.9L252,52.69l.27.16,31,17.9ZM222.94,70.75,252,87.53l29.07-16.78L252,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.18,106.23,250.9,88.17l31.28-18.06,31.29,18.06ZM253.11,88.17,282.18,105l29.07-16.78L282.18,71.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.36,123.66l-.27-.16-31-17.91,31.28-18.06.28.16,31,17.9Zm-29.07-18.07,29.07,16.79,29.07-16.79L312.36,88.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.54,141.08l-.28-.16-31-17.9L342.54,105l.27.16,31,17.91ZM313.47,123l29.07,16.78L371.61,123l-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.72,158.5l-.28-.16-31-17.9,31.29-18.06L404,140.44Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.65,88.81l-.27-.16-31-17.9,31.28-18.07.28.16,31,17.91ZM162.58,70.75l29.07,16.78,29.07-16.78L191.65,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.83,106.23l-.28-.16-31-17.9,31.28-18.06.28.16,31,17.9ZM192.76,88.17,221.83,105,250.9,88.17,221.83,71.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252,123.66l-.28-.16-31-17.91L252,87.53l31.28,18.06Zm-29.07-18.07L252,122.38l29.07-16.79L252,88.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.19,141.08,250.9,123,282.18,105l.28.16,31,17.91ZM253.12,123l29.07,16.78L311.25,123l-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.36,158.5l-.27-.16-31-17.9,31.28-18.06.28.16,31,17.9Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.54,175.92l-.28-.16-31-17.9,31.28-18.06.28.16,31,17.9Zm-29.07-18.06,29.07,16.79,29.07-16.79-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.72,193.35l-.28-.16-31-17.9,31.29-18.07.27.16,31,17.91Zm-29.07-18.06,29.07,16.78,29.07-16.78L372.72,158.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.3,88.81l-.28-.16-31-17.9L131.3,52.68l.27.16,31,17.91ZM102.23,70.75,131.3,87.53l29.07-16.78L131.3,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.48,106.23,130.19,88.17l31.29-18.06.27.16,31,17.9ZM132.41,88.17,161.48,105l29.07-16.78L161.48,71.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.65,123.66l-.27-.16-31-17.91,31.28-18.06.28.16,31,17.9Zm-29.07-18.07,29.07,16.79,29.07-16.79L191.65,88.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.83,141.08l-.27-.16-31-17.9L221.83,105l.28.16,31,17.91ZM192.76,123l29.07,16.78L250.9,123l-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252,158.5l-31.29-18.06L252,122.38l31.28,18.06Zm-29.07-18.06L252,157.22l29.07-16.78L252,123.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.19,175.92l-.28-.16-31-17.9,31.29-18.06.27.16,31,17.9Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.36,193.35l-31.28-18.07,31.28-18.06.28.16,31,17.91Zm-29.07-18.07,29.07,16.79,29.07-16.78L312.36,158.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.54,210.77l-.27-.16-31-17.9,31.28-18.06.28.16,31,17.9Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.72,228.19l-.28-.16-31-17.9,31.29-18.06.27.16,31,17.9Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.94,88.81l-.27-.16-31-17.9L70.94,52.68l.28.16,31,17.91ZM41.87,70.75,70.94,87.53,100,70.75,70.94,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.12,106.23l-.27-.16-31-17.9,31.28-18.06.28.16,31,17.9ZM72.05,88.17,101.12,105l29.07-16.78L101.12,71.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.3,123.65l-.28-.16-31-17.9L131.3,87.53l31.28,18.06Zm-29.07-18.06,29.07,16.78,29.07-16.78L131.3,88.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.48,141.08,130.19,123,161.48,105l.27.16,31,17.91ZM132.41,123l29.07,16.79L190.55,123l-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.65,158.5l-.27-.16-31-17.9,31.28-18.06.28.16,31,17.9Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.83,175.92l-31.28-18.06,31.28-18.06,31.29,18.06Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252,193.35l-.28-.16-31-17.91L252,157.22l.27.16,31,17.9Zm-29.07-18.07L252,192.07l29.07-16.79L252,158.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.19,210.77l-.28-.16-31-17.9,31.29-18.07,31.28,18.07Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.36,228.19l-31.28-18.06,31.28-18.06.28.16,31,17.9Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.54,245.62l-.27-.16-31-17.91,31.28-18.06.28.16,31,17.9Zm-29.07-18.07,29.07,16.79,29.07-16.79-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.72,263l-.28-.16-31-17.9,31.28-18.07.28.16L404,245ZM343.65,245l29.07,16.78L401.79,245l-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.94,123.65l-.27-.16-31-17.9L70.94,87.53l.28.16,31,17.9ZM41.87,105.59l29.07,16.78L100,105.59,70.94,88.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.12,141.08l-.27-.16L69.84,123,101.12,105l.28.16,31,17.9ZM72.05,123l29.07,16.79L130.19,123l-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.3,158.5l-.28-.16-31-17.9,31.28-18.07,31.28,18.07Zm-29.07-18.06,29.07,16.78,29.07-16.78L131.3,123.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.48,175.92l-.28-.16-31-17.9,31.29-18.06.27.16,31,17.9Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.66,193.35l-31.29-18.07,31.28-18.06,31.29,18.06Zm-29.07-18.07,29.07,16.79,29.06-16.79L191.65,158.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.83,210.77l-31.28-18.06,31.28-18.07.28.16,31,17.91Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252,228.19l-.28-.16-31-17.9L252,192.07l.28.16,31,17.9Zm-29.07-18.06L252,226.91l29.07-16.78L252,193.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.19,245.62l-.28-.16-31-17.91,31.29-18.06,31.28,18.06Zm-29.07-18.07,29.07,16.79,29.07-16.79-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.37,263l-.28-.16-31-17.9,31.28-18.07.28.16,31,17.91ZM283.3,245l29.07,16.78L341.44,245l-29.08-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.54,280.46,311.26,262.4l31.28-18.06.28.16,31,17.9ZM313.47,262.4l29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M372.72,297.88l-.28-.16-31-17.9,31.28-18.06.28.16,31,17.9Zm-29.07-18.06,29.07,16.79,29.07-16.79L372.72,263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,158.5,39.66,140.44l31.28-18.07.28.17,31,17.9ZM41.88,140.44,71,157.22,100,140.44,70.94,123.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.12,175.92l-.27-.16-31-17.9,31.28-18.06.28.16,31,17.9ZM72.05,157.86l29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.3,193.35l-.28-.16-31-17.91,31.28-18.06.28.16,31,17.9Zm-29.07-18.07,29.07,16.79,29.07-16.79L131.3,158.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.48,210.77l-.28-.16-31-17.9,31.29-18.07,31.28,18.07Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.66,228.19l-31.29-18.06,31.29-18.06,31.28,18.06Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.83,245.62l-31.28-18.07,31.28-18.06.28.16,31,17.9Zm-29.07-18.07,29.07,16.79,29.07-16.79-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252,263l-.28-.16-31-17.9L252,226.91l.28.16,31,17.91ZM222.94,245,252,261.76,281.08,245,252,228.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.19,280.46l-.28-.16-31-17.9,31.29-18.06.27.16,31,17.9ZM253.12,262.4l29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.37,297.88l-.28-.16-31-17.9,31.29-18.06,31.28,18.06ZM283.3,279.82l29.07,16.78,29.07-16.78L312.37,263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,193.35,39.66,175.28,71,157.22l.27.16,31,17.9ZM41.88,175.28,71,192.07,100,175.28,71,158.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.12,210.77l-.27-.16-31-17.9,31.28-18.07.28.16,31,17.91ZM72.05,192.71l29.07,16.78,29.07-16.78-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.3,228.19,131,228l-31-17.9,31.28-18.06.28.16,31,17.9Zm-29.07-18.06,29.07,16.78,29.07-16.78L131.3,193.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.48,245.61l-31.29-18.06,31.29-18.06,31.28,18.06Zm-29.07-18.06,29.07,16.78,29.07-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.66,263l-.28-.16-31-17.91,31.29-18.06L222.94,245ZM162.59,245l29.07,16.79L220.73,245l-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.83,280.46,190.55,262.4l31.28-18.06.28.16,31,17.9ZM192.76,262.4l29.07,16.78L250.9,262.4l-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252,297.88l-.27-.16-31-17.9L252,261.76l.28.16,31,17.9Zm-29.07-18.06L252,296.6l29.07-16.78L252,263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,228.19l-.28-.16-31-17.9L71,192.07l.27.16,31,17.9ZM41.88,210.13,71,226.91,100,210.13,71,193.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.13,245.61,69.84,227.55l31.28-18.06.28.16,31,17.9ZM72.06,227.55l29.07,16.78,29.06-16.78-29.07-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.3,263l-.27-.16L100,245l31.28-18.06L162.59,245ZM102.23,245l29.07,16.79L160.37,245,131.3,228.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.48,280.46,130.2,262.4l31.28-18.07.28.17,31,17.9ZM132.41,262.4l29.07,16.78,29.07-16.78-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.66,297.88l-.28-.16-31-17.9,31.29-18.06,31.28,18.06Zm-29.07-18.06,29.07,16.78,29.07-16.78L191.66,263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,263l-.28-.16L39.66,245,71,226.91,102.23,245ZM41.88,245,71,261.76,100,245,71,228.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.13,280.46l-.28-.16-31-17.9,31.29-18.07.27.17,31,17.9ZM72.06,262.4l29.07,16.78L130.2,262.4l-29.07-16.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.3,297.88,100,279.82l31.28-18.06,31.29,18.06Zm-29.07-18.06L131.3,296.6l29.07-16.78L131.3,263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,297.88l-.28-.16-31-17.9L71,261.76l.28.16,31,17.9ZM41.88,279.82,71,296.6,100,279.82,71,263Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40,204.48a10.45,10.45,0,0,0-1.7,1.25c-.24-7.67-5.78-10.73-12.6-6.79-5.55,3.21-10.26,10.07-11.95,16.8A7.55,7.55,0,0,0,9,216.91c-5,2.87-9,9.85-9,15.59s4,8.07,9,5.2l31-17.87a14.71,14.71,0,0,0,6.65-11.51C46.61,204.08,43.63,202.36,40,204.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.14,251.48a6.47,6.47,0,0,1-2.92,5.06c-1.61.93-2.92.17-2.92-1.69a6.45,6.45,0,0,1,2.92-5C278.83,248.87,280.14,249.62,280.14,251.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.6,246a6.44,6.44,0,0,1-2.92,5.06c-1.61.93-2.91.17-2.91-1.69a6.47,6.47,0,0,1,2.91-5.06C288.3,243.4,289.6,244.16,289.6,246Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.07,240.56a6.45,6.45,0,0,1-2.92,5.05c-1.62.93-2.92.18-2.92-1.68a6.44,6.44,0,0,1,2.92-5.06C297.76,237.94,299.07,238.7,299.07,240.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.53,235.09a6.45,6.45,0,0,1-2.92,5.06c-1.61.93-2.92.18-2.92-1.68a6.45,6.45,0,0,1,2.92-5.06C307.22,232.48,308.53,233.23,308.53,235.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.86,303.66a6.44,6.44,0,0,1-2.92,5.06c-1.61.93-2.91.17-2.91-1.69a6.44,6.44,0,0,1,2.91-5C142.56,301.05,143.86,301.8,143.86,303.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.92,299a6.47,6.47,0,0,1-2.92,5.06c-1.61.93-2.92.17-2.92-1.69a6.45,6.45,0,0,1,2.92-5.05C150.61,296.4,151.92,297.15,151.92,299Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.86,294.36a6.43,6.43,0,0,1-2.92,5.06c-1.61.93-2.91.18-2.91-1.69a6.44,6.44,0,0,1,2.91-5.05C142.56,291.75,143.86,292.5,143.86,294.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.92,289.71a6.45,6.45,0,0,1-2.92,5.06c-1.61.93-2.92.18-2.92-1.68A6.45,6.45,0,0,1,149,288C150.61,287.1,151.92,287.85,151.92,289.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.82 70.66 110.98 74.03 110.98 67.29 116.82 63.92 116.82 70.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "124.92 65.92 119.08 69.29 119.08 62.55 124.92 59.18 124.92 65.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.87 79.4 111.03 82.77 111.03 76.03 116.87 72.66 116.87 79.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "124.92 74.75 119.08 78.13 119.08 71.38 124.92 68.01 124.92 74.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M355,3.8a11.21,11.21,0,0,0-2.85,2.45C352,.63,348-1.62,343,1.25a16.6,16.6,0,0,0-4.4,3.83c-2.21-3.87-6.79-4.76-12.1-1.7C319,7.69,313,18.18,313,26.8a16.15,16.15,0,0,0,.14,2,5.07,5.07,0,0,0-3.79.76,14.3,14.3,0,0,0-6.47,11.2c0,4.13,2.9,5.8,6.47,3.74L355,18.16A13.73,13.73,0,0,0,361.2,7.39C361.2,3.42,358.42,1.81,355,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M363.12,11a10.88,10.88,0,0,0-2.85,2.45c-.14-5.63-4.17-7.87-9.14-5a16.56,16.56,0,0,0-4.39,3.83c-2.21-3.87-6.79-4.77-12.1-1.7-7.47,4.31-13.52,14.8-13.52,23.42a16,16,0,0,0,.13,2,5.13,5.13,0,0,0-3.79.77A14.29,14.29,0,0,0,311,48c0,4.13,2.89,5.8,6.46,3.74l45.66-26.36a13.76,13.76,0,0,0,6.22-10.77C369.34,10.59,366.55,9,363.12,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M371.26,18.14a11.08,11.08,0,0,0-2.86,2.45c-.13-5.63-4.16-7.87-9.13-5a16.38,16.38,0,0,0-4.39,3.83c-2.22-3.87-6.8-4.77-12.11-1.7-7.47,4.31-13.52,14.8-13.52,23.42a16,16,0,0,0,.14,2,5.13,5.13,0,0,0-3.79.77,14.3,14.3,0,0,0-6.47,11.2c0,4.13,2.9,5.8,6.47,3.74L371.26,32.5a13.77,13.77,0,0,0,6.21-10.77C377.47,17.76,374.69,16.15,371.26,18.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106.12,219.49a1.48,1.48,0,0,1-.71-.19,1.42,1.42,0,0,1-.7-1.22V200a1.41,1.41,0,0,1,.7-1.22l15.67-9.05a1.42,1.42,0,0,1,1.41,0,1.4,1.4,0,0,1,.7,1.22V209a1.39,1.39,0,0,1-.7,1.22l-15.67,9.05A1.44,1.44,0,0,1,106.12,219.49Zm1.41-18.69v14.83l12.84-7.41V193.39ZM121.78,209h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "95.36 307.78 72.77 294.73 95.36 281.69 117.95 294.73 95.36 307.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.36,299.7a1.76,1.76,0,0,1-.86-.23l-22.59-13a1.72,1.72,0,0,1,0-3l22.59-13a1.71,1.71,0,0,1,1.72,0l22.59,13a1.72,1.72,0,0,1,0,3l-22.59,13A1.76,1.76,0,0,1,95.36,299.7ZM76.21,284.94,95.36,296l19.16-11.06L95.36,273.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "117.95 274.75 95.36 287.79 95.36 261.71 117.95 248.66 117.95 274.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "95.36 261.71 72.77 248.66 95.36 235.62 117.95 248.66 95.36 261.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "95.36 287.79 72.77 274.75 72.77 248.66 95.36 261.71 95.36 287.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.23 273.7 80.91 270.05 80.91 262.76 87.23 266.4 87.23 273.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "348.3 167.28 325.71 154.24 348.3 141.19 370.89 154.24 348.3 167.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.3,159.2a1.68,1.68,0,0,1-.86-.23l-22.59-13a1.71,1.71,0,0,1,0-3l22.59-13.05a1.76,1.76,0,0,1,1.72,0L371.75,143a1.71,1.71,0,0,1,0,3l-22.59,13A1.63,1.63,0,0,1,348.3,159.2Zm-19.15-14.76L348.3,155.5l19.16-11.06L348.3,133.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "370.89 134.25 348.3 147.29 348.3 121.21 370.89 108.17 370.89 134.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "348.3 121.21 325.71 108.17 348.3 95.13 370.89 108.17 348.3 121.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "348.3 147.29 325.71 134.25 325.71 108.17 348.3 121.21 348.3 147.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "340.17 133.2 333.85 129.56 333.85 122.26 340.17 125.91 340.17 133.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "341.99 108.24 348.26 104.52 354.62 108.09 348.35 111.82 341.99 108.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "348.3 307.78 325.71 294.73 348.3 281.69 370.89 294.73 348.3 307.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.3,299.7a1.79,1.79,0,0,1-.86-.23l-22.59-13a1.72,1.72,0,0,1,0-3l22.59-13a1.71,1.71,0,0,1,1.72,0l22.59,13a1.72,1.72,0,0,1,0,3l-22.59,13A1.73,1.73,0,0,1,348.3,299.7Zm-19.15-14.76L348.3,296l19.16-11.06L348.3,273.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "370.89 274.75 348.3 287.79 348.3 261.71 370.89 248.66 370.89 274.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "348.3 261.71 325.71 248.66 348.3 235.62 370.89 248.66 348.3 261.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "348.3 287.79 325.71 274.75 325.71 248.66 348.3 261.71 348.3 287.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "340.17 273.7 333.85 270.05 333.85 262.76 340.17 266.4 340.17 273.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "95.36 167.28 72.77 154.24 95.36 141.19 117.95 154.24 95.36 167.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.36,159.2a1.66,1.66,0,0,1-.86-.23l-22.59-13a1.71,1.71,0,0,1,0-3L94.5,129.91a1.76,1.76,0,0,1,1.72,0L118.81,143a1.71,1.71,0,0,1,0,3L96.22,159A1.66,1.66,0,0,1,95.36,159.2ZM76.21,144.44,95.36,155.5l19.16-11.06L95.36,133.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "117.95 134.25 95.36 147.29 95.36 121.21 117.95 108.17 117.95 134.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "95.36 121.21 72.77 108.17 95.36 95.13 117.95 108.17 95.36 121.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "95.36 147.29 72.77 134.25 72.77 108.17 95.36 121.21 95.36 147.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.23 133.2 80.91 129.56 80.91 122.26 87.23 125.91 87.23 133.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265.91,
    y: 145.34,
    width: 75.86,
    height: 3.43,
    transform: "translate(-32.82 171.57) rotate(-29.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.5,259.4,158.57,226c-2.13-1.22-1.86-3.36.59-4.78l61.41-35.54c2.45-1.42,6.16-1.57,8.28-.35l57.94,33.45c2.12,1.23,1.85,3.37-.6,4.79l-61.41,35.54C222.33,260.48,218.62,260.63,216.5,259.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.11,248.41a9,9,0,0,1-4.47-1l-57.93-33.45a4.16,4.16,0,0,1-2.3-3.56,5.06,5.06,0,0,1,2.89-4.19l61.41-35.55c3-1.71,7.36-1.86,10-.34l57.93,33.45a4.16,4.16,0,0,1,2.3,3.56,5,5,0,0,1-2.89,4.19L225.65,247A11.39,11.39,0,0,1,220.11,248.41Zm-2.75-4c1.59.92,4.66.76,6.57-.35l61.4-35.54c.86-.5,1.17-1,1.17-1.22s-.18-.36-.57-.59L228,173.24c-1.59-.92-4.66-.75-6.57.35L160,209.13c-.86.5-1.17,1-1.17,1.22s.18.36.57.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M220.68,83.34s-31.81,3-51,4.5l50.81,144.71,67.21-38.76,0,0,.12-.07h0a3.74,3.74,0,0,0,1.37-3.32V48.93a10.21,10.21,0,0,0-1.16-4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M285.1,41,226,6.85a2.68,2.68,0,0,0-2.69-.23h0L155.82,45.55,159,57.32l16.92,48.18,3.19,1.84,109-62.93A8.35,8.35,0,0,0,285.1,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M217.67,232.42l-59.11-34.13c-2.3-1.32-4.16-4.88-4.16-7.95V48.9c0-3.07,1.86-4.48,4.16-3.15l59.11,34.13c2.3,1.32,4.16,4.88,4.16,8V229.27C221.83,232.34,220,233.75,217.67,232.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.94,79.16,159.83,45c-1.33-.77-2.51-.62-3.27.24a3.09,3.09,0,0,1,2,.47l59.11,34.13c2.3,1.32,4.16,4.88,4.16,8V229.27a4.3,4.3,0,0,1-.89,2.91c1.29-.2,2.16-1.52,2.16-3.62V87.12C223.1,84.05,221.24,80.49,218.94,79.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M214,223.9l-51.67-29.83c-2-1.16-3.64-4.27-3.64-6.95V55.76c0-2.68,1.63-3.91,3.64-2.75L214,82.84c2,1.16,3.64,4.27,3.64,7V221.15C217.59,223.83,216,225.07,214,223.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M214,223.9l-51.67-29.83c-2-1.16-3.64-4.27-3.64-6.95V55.76c0-2.68,1.63-3.91,3.64-2.75L214,82.84c2,1.16,3.64,4.27,3.64,7V221.15C217.59,223.83,216,225.07,214,223.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M214,223.9l-51.67-29.83c-2-1.16-3.64-4.27-3.64-6.95V55.76c0-2.68,1.63-3.91,3.64-2.75L214,82.84c2,1.16,3.64,4.27,3.64,7V221.15C217.59,223.83,216,225.07,214,223.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M215.64,222.91,164,193.08c-2-1.16-3.64-4.27-3.64-7V54.76a4.19,4.19,0,0,1,.52-2.19c-1.3,0-2.21,1.18-2.21,3.19V187.12c0,2.68,1.63,5.79,3.64,6.95L214,223.9c1.33.77,2.48.49,3.12-.55A3.05,3.05,0,0,1,215.64,222.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M214,163.59l-19.2-11.08-30.63,17.68,53.47,30.87V170.55C217.59,167.87,216,164.75,214,163.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M214,136.68l-19.2-11.09-30.63,17.68,53.47,30.88V143.63C217.59,141,216,137.84,214,136.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M214,109.76l-19.2-11.09-30.63,17.68,53.47,30.88V116.71C217.59,114,216,110.92,214,109.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M214,82.84l-19.2-11.09L164.12,89.44l53.47,30.87V89.79C217.59,87.11,216,84,214,82.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M214,82.84,171.43,58.29l-7.31,4.23,53.47,30.87v-3.6C217.59,87.11,216,84,214,82.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "217.59 93.39 164.12 62.52 164.12 79.53 217.59 110.41 217.59 93.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "217.59 120.31 164.12 89.44 164.12 106.45 217.59 137.32 217.59 120.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "217.59 147.23 164.12 116.35 164.12 133.37 217.59 164.24 217.59 147.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "217.59 174.15 164.12 143.27 164.12 160.29 217.59 191.16 217.59 174.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "217.59 201.06 164.12 170.19 164.12 187.2 217.59 218.08 217.59 201.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M212.87,104.34,172.6,81.09a4.93,4.93,0,0,1-2.06-3.94V72.6c0-1.52.92-2.22,2.06-1.56l40.27,23.25a4.93,4.93,0,0,1,2.06,3.94v4.56C214.93,104.3,214,105,212.87,104.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M174.63,80.22a4.93,4.93,0,0,1-2.06-3.94V71.72a2.63,2.63,0,0,1,.08-.65l-.05,0c-1.14-.66-2.06,0-2.06,1.56v4.55a4.93,4.93,0,0,0,2.06,3.94l40.27,23.25a1.24,1.24,0,0,0,2-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.23,91.85,176,77.86a1.74,1.74,0,0,1-.73-1.38h0c0-.54.33-.78.73-.55l24.23,14a1.74,1.74,0,0,1,.73,1.39h0C201,91.84,200.63,92.08,200.23,91.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M212.87,131.09,172.6,107.84a4.93,4.93,0,0,1-2.06-3.93V99.35c0-1.52.92-2.21,2.06-1.56l40.27,23.26a4.9,4.9,0,0,1,2.06,3.93v4.56C214.93,131.05,214,131.75,212.87,131.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M174.63,107a4.93,4.93,0,0,1-2.06-3.94V98.48a2.65,2.65,0,0,1,.08-.66l-.05,0c-1.14-.65-2.06,0-2.06,1.56v4.56a4.93,4.93,0,0,0,2.06,3.93l40.27,23.25a1.24,1.24,0,0,0,2-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.23,118.61l-24.23-14a1.74,1.74,0,0,1-.73-1.38h0c0-.54.33-.78.73-.55l24.23,14a1.74,1.74,0,0,1,.73,1.39h0C201,118.59,200.63,118.84,200.23,118.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M212.87,158.1,172.6,134.84a4.93,4.93,0,0,1-2.06-3.93v-4.56c0-1.52.92-2.21,2.06-1.56l40.27,23.26a4.92,4.92,0,0,1,2.06,3.93v4.56C214.93,158.05,214,158.75,212.87,158.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M174.63,134a4.93,4.93,0,0,1-2.06-3.94v-4.55a2.71,2.71,0,0,1,.08-.66l-.05,0c-1.14-.65-2.06,0-2.06,1.56v4.56a4.93,4.93,0,0,0,2.06,3.93l40.27,23.25a1.24,1.24,0,0,0,2-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M200.23,145.61l-24.23-14a1.74,1.74,0,0,1-.73-1.38h0c0-.53.33-.78.73-.55l24.23,14a1.74,1.74,0,0,1,.73,1.38h0C201,145.59,200.63,145.84,200.23,145.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M212.87,185.35,172.6,162.09a4.93,4.93,0,0,1-2.06-3.93V153.6c0-1.52.92-2.21,2.06-1.56l40.27,23.26a4.93,4.93,0,0,1,2.06,3.93v4.56C214.93,185.31,214,186,212.87,185.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M174.63,161.22a4.93,4.93,0,0,1-2.06-3.94v-4.55a2.71,2.71,0,0,1,.08-.66l-.05,0c-1.14-.65-2.06,0-2.06,1.56v4.56a4.93,4.93,0,0,0,2.06,3.93l40.27,23.26a1.24,1.24,0,0,0,2-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M200.23,172.86l-24.23-14a1.74,1.74,0,0,1-.73-1.38h0c0-.53.33-.78.73-.55l24.23,14a1.74,1.74,0,0,1,.73,1.38h0C201,172.84,200.63,173.09,200.23,172.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M212.87,212.06,172.6,188.8a4.92,4.92,0,0,1-2.06-3.93v-4.56c0-1.51.92-2.21,2.06-1.56L212.87,202a4.93,4.93,0,0,1,2.06,3.93v4.56C214.93,212,214,212.71,212.87,212.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M174.63,187.93a4.93,4.93,0,0,1-2.06-3.93v-4.56a2.71,2.71,0,0,1,.08-.66l-.05,0c-1.14-.65-2.06,0-2.06,1.56v4.56a4.92,4.92,0,0,0,2.06,3.93l40.27,23.26a1.24,1.24,0,0,0,2-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M200.23,199.57l-24.23-14a1.74,1.74,0,0,1-.73-1.38h0c0-.53.33-.78.73-.55l24.23,14A1.74,1.74,0,0,1,201,199h0C201,199.55,200.63,199.8,200.23,199.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "164.12 62.52 168.33 64.95 168.33 81.96 164.12 79.53 164.12 62.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "164.12 89.44 168.33 91.87 168.33 108.88 164.12 106.45 164.12 89.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "164.12 116.35 168.33 118.78 168.33 135.8 164.12 133.37 164.12 116.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "164.12 143.27 168.33 145.7 168.33 162.72 164.12 160.29 164.12 143.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "164.12 170.19 168.33 172.62 168.33 189.63 164.12 187.2 164.12 170.19"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 204.16,
    cy: 93.04,
    rx: 0.7,
    ry: 1.21,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -19.17, 114.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M208.62,95.62c0,.54-.38.76-.85.49a1.87,1.87,0,0,1-.85-1.47c0-.55.38-.77.85-.5A1.91,1.91,0,0,1,208.62,95.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M212.24,97.71c0,.54-.38.76-.85.49a1.89,1.89,0,0,1-.86-1.48c0-.54.39-.76.86-.49A1.88,1.88,0,0,1,212.24,97.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M205,120.44c0,.54-.38.76-.85.49a1.89,1.89,0,0,1-.86-1.48c0-.54.39-.76.86-.49A1.88,1.88,0,0,1,205,120.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M208.62,122.52c0,.55-.38.77-.85.5a1.89,1.89,0,0,1-.85-1.48c0-.54.38-.76.85-.49A1.87,1.87,0,0,1,208.62,122.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.24,124.61c0,.55-.38.77-.85.49a1.89,1.89,0,0,1-.86-1.47c0-.55.39-.77.86-.49A1.87,1.87,0,0,1,212.24,124.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205,147.55c0,.54-.38.76-.85.49a1.89,1.89,0,0,1-.86-1.48c0-.54.39-.76.86-.49A1.88,1.88,0,0,1,205,147.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M208.62,149.63c0,.55-.38.77-.85.5a1.91,1.91,0,0,1-.85-1.48c0-.55.38-.77.85-.49A1.87,1.87,0,0,1,208.62,149.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.24,151.72c0,.54-.38.76-.85.49a1.89,1.89,0,0,1-.86-1.47c0-.55.39-.77.86-.5A1.89,1.89,0,0,1,212.24,151.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205,174.26c0,.54-.38.76-.85.49a1.89,1.89,0,0,1-.86-1.48c0-.54.39-.76.86-.49A1.89,1.89,0,0,1,205,174.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M208.62,176.35c0,.54-.38.76-.85.49a1.88,1.88,0,0,1-.85-1.48c0-.54.38-.76.85-.49A1.88,1.88,0,0,1,208.62,176.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M212.24,178.43c0,.55-.38.77-.85.49a1.89,1.89,0,0,1-.86-1.47c0-.55.39-.77.86-.49A1.87,1.87,0,0,1,212.24,178.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205,201.34c0,.54-.38.76-.85.49a1.89,1.89,0,0,1-.86-1.48c0-.54.39-.76.86-.49A1.88,1.88,0,0,1,205,201.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M208.62,203.42c0,.55-.38.77-.85.5a1.91,1.91,0,0,1-.85-1.48c0-.55.38-.77.85-.49A1.87,1.87,0,0,1,208.62,203.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M212.24,205.51c0,.54-.38.76-.85.49a1.89,1.89,0,0,1-.86-1.47c0-.55.39-.77.86-.5A1.91,1.91,0,0,1,212.24,205.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M230.73,213.3V92.86l.25-.15,50.34-29.06V184.1l-.25.14Zm1-119.87V211.57l48.59-28V65.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M268.24,117.84l-22.57,13c-1.51.88-2.74-.05-2.74-2.07V116.29a6.59,6.59,0,0,1,2.74-5.25l22.57-13c1.52-.88,2.75,0,2.75,2.07V112.6A6.55,6.55,0,0,1,268.24,117.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M268.79,97.77A3.59,3.59,0,0,1,269,99v12.52a6.55,6.55,0,0,1-2.75,5.24l-22.57,13a2.36,2.36,0,0,1-.55.24,1.59,1.59,0,0,0,2.54.82l22.57-13A6.55,6.55,0,0,0,271,112.6V100.08C271,98.31,270.05,97.38,268.79,97.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264.12,110.31c.42-.24.76,0,.76.43v2.85a1.66,1.66,0,0,1-.76,1.31c-.42.24-.75,0-.75-.43v-2.85A1.65,1.65,0,0,1,264.12,110.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M260.88,112.53c.42-.24.76,0,.76.44v2.49a1.66,1.66,0,0,1-.76,1.31c-.41.24-.75,0-.75-.43v-2.5A1.69,1.69,0,0,1,260.88,112.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M257.65,111.62c.41-.24.75-.05.75.44v5.27a1.69,1.69,0,0,1-.75,1.31c-.42.24-.76,0-.76-.43v-5.28A1.67,1.67,0,0,1,257.65,111.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M254.41,110.45c.42-.24.75,0,.75.43v8.32a1.66,1.66,0,0,1-.75,1.31c-.42.24-.76,0-.76-.44v-8.31A1.66,1.66,0,0,1,254.41,110.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M251.17,113.19c.42-.24.76,0,.76.44v7.44a1.67,1.67,0,0,1-.76,1.31c-.42.24-.75.05-.75-.44V114.5A1.66,1.66,0,0,1,251.17,113.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M247.93,118.46c.42-.24.76,0,.76.44v4a1.67,1.67,0,0,1-.76,1.31c-.41.24-.75,0-.75-.44v-4A1.69,1.69,0,0,1,247.93,118.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M263.38,108.87c0,.47.33.66.74.43a1.66,1.66,0,0,0,.74-1.29c0-.47-.33-.67-.74-.43A1.64,1.64,0,0,0,263.38,108.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 264.12,
    cy: 105.76,
    rx: 1.05,
    ry: 0.61,
    transform: "translate(40.46 281.61) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 346.59,
    y: 41.54,
    width: 3.44,
    height: 66.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M218,320.51l-34.51-19.93c-2.12-1.22-1.85-3.36.6-4.77l33.32-19.24c2.45-1.41,6.15-1.56,8.26-.34l34.52,19.93c2.11,1.22,1.85,3.36-.6,4.77l-33.32,19.24C223.81,321.58,220.11,321.73,218,320.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.6,312.4a9.19,9.19,0,0,1-4.58-1.1h0L182.5,291.38a4.41,4.41,0,0,1-2.41-3.77,5.28,5.28,0,0,1,3-4.4L216.42,264c3.08-1.78,7.48-1.93,10.22-.34l34.52,19.92a4.41,4.41,0,0,1,2.41,3.77,5.28,5.28,0,0,1-3,4.4L227.24,311A11.57,11.57,0,0,1,221.6,312.4ZM219,307.91c1.53.88,4.47.72,6.31-.34l33.32-19.24c.84-.49,1-.93,1-1a1.56,1.56,0,0,0-.45-.37L224.68,267c-1.52-.87-4.46-.72-6.3.35l-33.32,19.24c-.84.48-1,.92-1.05,1a1.4,1.4,0,0,0,.45.37L219,307.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M261.6,275.11h0v-11.9l-26.71,0-9.23-5.33c-2.11-1.22-5.81-1.07-8.26.34l-8.61,5-26.73,0v12.25a2.4,2.4,0,0,0,1.42,2.21L218,297.55c2.12,1.22,5.82,1.07,8.27-.34L259.58,278C261,277.15,261.67,276.1,261.6,275.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M221.83,257a9.6,9.6,0,0,0-4.43,1.16l-8.61,5-26.73,0v12.25a2.4,2.4,0,0,0,1.42,2.21L218,297.55a7.54,7.54,0,0,0,3.84.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M185.09,263.16h-3v12.25a2.4,2.4,0,0,0,1.42,2.21l1.61.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M218.53,297.81a9.39,9.39,0,0,0,6.6-.08v-13.9h-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M218,285.35l-34.51-19.93c-2.12-1.22-1.85-3.36.6-4.77l33.32-19.24c2.45-1.41,6.15-1.57,8.26-.34L260.18,261c2.11,1.22,1.85,3.36-.6,4.77L226.26,285C223.81,286.41,220.11,286.57,218,285.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.58,263.42l-33.32,19.24c-2.45,1.41-6.15,1.56-8.27.34l-34.51-19.92a3.25,3.25,0,0,1-1-.94c-.73,1.17-.4,2.44,1,3.28L218,285.35c2.12,1.22,5.82,1.06,8.27-.35l33.32-19.24c1.9-1.09,2.48-2.63,1.65-3.83A4.59,4.59,0,0,1,259.58,263.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M248.9,278.26a3.06,3.06,0,0,1-1.39,2.41c-.77.45-1.4.08-1.4-.8a3.1,3.1,0,0,1,1.4-2.42C248.28,277,248.9,277.37,248.9,278.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M253.39,275.67a3.07,3.07,0,0,1-1.4,2.41c-.77.45-1.39.09-1.39-.8a3.09,3.09,0,0,1,1.39-2.42C252.76,274.42,253.39,274.78,253.39,275.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M257.87,273.08a3.06,3.06,0,0,1-1.39,2.41c-.77.45-1.4.09-1.4-.8a3.1,3.1,0,0,1,1.4-2.42C257.25,271.83,257.87,272.19,257.87,273.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M220,273l-16.15-9.32c-1-.57-.87-1.57.27-2.24l15.6-9a4.29,4.29,0,0,1,3.86-.16l16.15,9.33c1,.57.87,1.57-.27,2.23l-15.6,9A4.29,4.29,0,0,1,220,273Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M221.58,265.18l-2.23-1.29c-.14-.07-.12-.21,0-.3l2.15-1.25a.61.61,0,0,1,.54,0l2.23,1.29c.14.08.12.22,0,.31l-2.15,1.24A.61.61,0,0,1,221.58,265.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M203.89,263.67l0,0,.23-.16,15.6-9a4.29,4.29,0,0,1,3.86-.16l16.11,9.3c.91-.66,1-1.55,0-2.07l-16.15-9.33a4.29,4.29,0,0,0-3.86.16l-15.6,9C203,262.1,202.89,263.1,203.89,263.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M344.47,232.59,310,212.67c-2.12-1.23-1.86-3.36.59-4.77l33.32-19.24c2.45-1.42,6.15-1.57,8.27-.35l34.51,19.93c2.12,1.22,1.85,3.36-.59,4.77l-33.33,19.24C350.29,233.66,346.59,233.81,344.47,232.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M348.08,224.48a9.22,9.22,0,0,1-4.59-1.1h0L309,203.46a4.38,4.38,0,0,1-2.41-3.77,5.29,5.29,0,0,1,3-4.4l33.32-19.24c3.09-1.78,7.48-1.93,10.23-.34l34.51,19.93a4.38,4.38,0,0,1,2.41,3.77,5.28,5.28,0,0,1-3,4.39L353.71,223A11.4,11.4,0,0,1,348.08,224.48ZM345.45,220c1.52.88,4.46.72,6.3-.34l33.33-19.24c.83-.49,1-.92,1-1a1.13,1.13,0,0,0-.45-.38l-34.51-19.92c-1.52-.88-4.47-.72-6.3.34l-33.33,19.24c-.84.48-1,.92-1,1a1.16,1.16,0,0,0,.45.37L345.45,220Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M388.07,187.2h0V175.29l-26.7,0-9.23-5.33c-2.12-1.22-5.82-1.07-8.27.35l-8.61,5-26.72,0v12.25A2.38,2.38,0,0,0,310,189.7l34.51,19.93c2.12,1.22,5.82,1.07,8.26-.34l33.33-19.24C387.47,189.23,388.15,188.18,388.07,187.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M348.3,169.13a9.36,9.36,0,0,0-4.43,1.16l-8.61,5-26.72,0v12.25A2.38,2.38,0,0,0,310,189.7l34.51,19.93a7.5,7.5,0,0,0,3.83.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M311.56,175.25h-3v12.25A2.38,2.38,0,0,0,310,189.7l1.6.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M345,209.89a9.41,9.41,0,0,0,6.61-.08v-13.9H345Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M344.47,197.43,310,177.5c-2.12-1.22-1.86-3.36.59-4.77l33.32-19.24c2.45-1.41,6.15-1.56,8.27-.34l34.51,19.92c2.12,1.23,1.85,3.36-.59,4.78l-33.33,19.23C350.29,198.5,346.59,198.65,344.47,197.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M386.06,175.5l-33.33,19.24c-2.44,1.41-6.14,1.57-8.26.34L310,175.16a3.08,3.08,0,0,1-1.06-.94c-.73,1.17-.4,2.44,1.06,3.28l34.51,19.93c2.12,1.22,5.82,1.07,8.26-.35l33.33-19.23c1.9-1.1,2.47-2.63,1.65-3.84A4.67,4.67,0,0,1,386.06,175.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M375.37,190.34a3.06,3.06,0,0,1-1.39,2.41c-.77.45-1.39.09-1.39-.8a3.09,3.09,0,0,1,1.39-2.42C374.75,189.09,375.37,189.45,375.37,190.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M379.86,187.75a3.06,3.06,0,0,1-1.39,2.41c-.77.45-1.4.09-1.4-.8a3.1,3.1,0,0,1,1.4-2.42C379.24,186.5,379.86,186.86,379.86,187.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M384.34,185.16a3.06,3.06,0,0,1-1.39,2.41c-.77.45-1.39.09-1.39-.8a3.06,3.06,0,0,1,1.39-2.41C383.72,183.91,384.34,184.27,384.34,185.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M346.51,185.07l-16.15-9.32c-1-.57-.87-1.57.28-2.23l15.59-9a4.31,4.31,0,0,1,3.87-.16l16.15,9.33c1,.57.87,1.57-.28,2.23l-15.59,9A4.28,4.28,0,0,1,346.51,185.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M348.06,177.27,345.82,176c-.14-.08-.12-.22,0-.31l2.16-1.25a.59.59,0,0,1,.53,0l2.24,1.29c.13.08.12.22,0,.31l-2.16,1.24A.56.56,0,0,1,348.06,177.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M330.36,175.75l.05,0a1.34,1.34,0,0,1,.23-.16l15.59-9a4.31,4.31,0,0,1,3.87-.16l16.1,9.3c.92-.65,1-1.54.05-2.07l-16.15-9.33a4.31,4.31,0,0,0-3.87.16l-15.59,9C329.49,174.18,329.37,175.18,330.36,175.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M91.53,232.59,57,212.67c-2.11-1.23-1.85-3.36.6-4.77l33.32-19.24c2.45-1.42,6.15-1.57,8.27-.35l34.51,19.93c2.12,1.22,1.85,3.36-.6,4.77L99.79,232.25C97.34,233.66,93.64,233.81,91.53,232.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.13,224.48a9.21,9.21,0,0,1-4.58-1.1h0L56,203.46a4.4,4.4,0,0,1-2.41-3.77,5.3,5.3,0,0,1,3-4.4L90,176.05c3.09-1.78,7.48-1.93,10.23-.34l34.51,19.93a4.38,4.38,0,0,1,2.41,3.77,5.28,5.28,0,0,1-3,4.39L100.77,223A11.41,11.41,0,0,1,95.13,224.48ZM92.51,220c1.52.88,4.46.72,6.3-.34l33.32-19.24c.84-.49,1-.92,1.05-1a1.23,1.23,0,0,0-.45-.38L98.22,179.11c-1.53-.88-4.47-.72-6.31.34L58.59,198.69c-.84.48-1,.92-1.05,1a1.4,1.4,0,0,0,.45.37L92.51,220Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M135.13,187.2h0V175.29l-26.7,0-9.23-5.33c-2.12-1.22-5.82-1.07-8.27.35l-8.61,5-26.72,0v12.25A2.38,2.38,0,0,0,57,189.7l34.52,19.93c2.11,1.22,5.81,1.07,8.26-.34l33.32-19.24C134.53,189.23,135.21,188.18,135.13,187.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M95.36,169.13a9.36,9.36,0,0,0-4.43,1.16l-8.61,5-26.72,0v12.25A2.38,2.38,0,0,0,57,189.7l34.52,19.93a7.48,7.48,0,0,0,3.83.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M58.62,175.25h-3v12.25A2.38,2.38,0,0,0,57,189.7l1.61.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M92.06,209.89a9.39,9.39,0,0,0,6.6-.08v-13.9h-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M91.53,197.43,57,177.5c-2.11-1.22-1.85-3.36.6-4.77l33.32-19.24c2.45-1.41,6.15-1.56,8.27-.34l34.51,19.92c2.12,1.23,1.85,3.36-.6,4.78L99.79,197.08C97.34,198.5,93.64,198.65,91.53,197.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.11,175.5,99.79,194.74c-2.45,1.41-6.15,1.57-8.26.34L57,175.16a3.14,3.14,0,0,1-1-.94c-.73,1.17-.4,2.44,1,3.28l34.52,19.93c2.11,1.22,5.81,1.07,8.26-.35l33.32-19.23c1.9-1.1,2.48-2.63,1.65-3.84A4.5,4.5,0,0,1,133.11,175.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M122.43,190.34a3.06,3.06,0,0,1-1.39,2.41c-.77.45-1.4.09-1.4-.8a3.1,3.1,0,0,1,1.4-2.42C121.81,189.09,122.43,189.45,122.43,190.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M126.92,187.75a3.07,3.07,0,0,1-1.4,2.41c-.77.45-1.39.09-1.39-.8a3.09,3.09,0,0,1,1.39-2.42C126.29,186.5,126.92,186.86,126.92,187.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M131.4,185.16a3.06,3.06,0,0,1-1.39,2.41c-.77.45-1.4.09-1.4-.8a3.07,3.07,0,0,1,1.4-2.41C130.78,183.91,131.4,184.27,131.4,185.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M93.57,185.07l-16.15-9.32c-1-.57-.87-1.57.27-2.23l15.6-9a4.31,4.31,0,0,1,3.87-.16l16.15,9.33c1,.57.86,1.57-.28,2.23l-15.6,9A4.26,4.26,0,0,1,93.57,185.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M95.11,177.27,92.88,176c-.14-.08-.12-.22,0-.31l2.15-1.25a.61.61,0,0,1,.54,0l2.23,1.29c.14.08.12.22,0,.31l-2.16,1.24A.58.58,0,0,1,95.11,177.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M77.42,175.75l0,0,.23-.16,15.6-9a4.31,4.31,0,0,1,3.87-.16l16.1,9.3c.91-.65,1-1.54,0-2.07l-16.15-9.33a4.31,4.31,0,0,0-3.87.16l-15.6,9C76.55,174.18,76.43,175.18,77.42,175.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.f29d6ce00f764ffc7603cb35645c48d8.svg";
export { ForwardRef as ReactComponent };